/** 后端 auth 等：须修改初始密码 */
export const USER_NEED_CHANGE_PASSWORD_KEY = 'needChangePassword' as const;
/** GET /own：密码是否仍为系统初始密码，true 表示须强制改密 */
export const USER_INITIAL_PASSWORD_UNCHANGED_KEY = 'initialPasswordUnchanged' as const;

/** 是否须强制修改初始密码（auth 的 needChangePassword 或 /own 的 initialPasswordUnchanged 任一为真） */
export function readUserNeedChangePassword(user: Record<string, unknown> | null | undefined): boolean {
  if (!user) return false;
  if (user[USER_NEED_CHANGE_PASSWORD_KEY] === true) return true;
  if (user[USER_INITIAL_PASSWORD_UNCHANGED_KEY] === true) return true;
  return false;
}
